import React from "react";
import LookupFormPage from "./LookupFormPage";

function ImplementorFormPage() {
  return (
    <LookupFormPage
      title="Implementor"
      endpoint="/implementors"
      listPath="/implementors"
      fields={[
        { name: "name", label: "Name" },
        { name: "contact", label: "Contact", required: false },
        { name: "focalperson", label: "Focal person", required: false }
      ]}
    />
  );
}

export default ImplementorFormPage;
